"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryPropertyValue = exports.TelemetryPropertyKey = void 0;
var TelemetryPropertyKey;
(function (TelemetryPropertyKey) {
    TelemetryPropertyKey["updateExistingApp"] = "update";
    TelemetryPropertyKey["publishedAppId"] = "published-app-id";
    TelemetryPropertyKey["customizedKeys"] = "customized-manifest-keys";
    TelemetryPropertyKey["customizedOpenAPIKeys"] = "customized-openapi-keys";
    TelemetryPropertyKey["customizedAIPluginKeys"] = "customized-ai-plugin-keys";
    TelemetryPropertyKey["customizedCopilotGptKeys"] = "customized-copilot-gpt-keys";
    TelemetryPropertyKey["validationErrors"] = "validation-errors";
    TelemetryPropertyKey["validationWarnings"] = "validation-warnings";
    TelemetryPropertyKey["OverwriteIfAppAlreadyExists"] = "overwrite-if-app-already-exists";
    TelemetryPropertyKey["region"] = "region";
    TelemetryPropertyKey["pluginValidationErrors"] = "plugin-validation-errors";
    TelemetryPropertyKey["gptValidationErrors"] = "gpt-validation-errors";
    TelemetryPropertyKey["gptActionValidationErrors"] = "gpt-action-validation-errors";
    TelemetryPropertyKey["localizationValidationErrors"] = "localization-validation-errors";
})(TelemetryPropertyKey || (exports.TelemetryPropertyKey = TelemetryPropertyKey = {}));
var TelemetryPropertyValue;
(function (TelemetryPropertyValue) {
    TelemetryPropertyValue["Global"] = "global";
})(TelemetryPropertyValue || (exports.TelemetryPropertyValue = TelemetryPropertyValue = {}));
//# sourceMappingURL=telemetry.js.map